import { render } from "./Notificaciones.vue?vue&type=template&id=3a49c2f8&scoped=true"
import script from "./Notificaciones.vue?vue&type=script&lang=js"
export * from "./Notificaciones.vue?vue&type=script&lang=js"

import "./Notificaciones.vue?vue&type=style&index=0&id=3a49c2f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a49c2f8"]])

export default __exports__